<template>
  <section class="print">
    <h3 v-if="showHeader" class="print-color subtitle-border mb-2">{{ $t('report_preview.findings') }}:</h3>
    <!-- 增加胃鏡搭配finding 示意圖 -->
    <div v-if="showGlobalMap" class="align-center highlight-area">
      <div v-if="gastroFindings || spots" align="center" class="pos-relative global-preview-map">
        <img src="/img/gastro-preview-img.png" alt="" />

        <!-- EVAS2.0：直接給座標編號，不畫序號。理由同 FindingInfoByOrder -->
        <template v-if="spots">
          <div
            class="highlight-point highlight-point--plain"
            :class="`highlight-${index}`"
            v-for="index in spots"
            :key="'spot' + index"
          >
            <div class="highlight-inner-point"></div>
          </div>
        </template>

        <template v-else>
          <div
            class="highlight-point"
            :class="`highlight-${getLocation(value)}`"
            v-for="(value, key) in findings"
            :key="'highlight'+value.id"
            v-if="getLocation(value) !== null"
          >
            <div class="highlight-inner-point">{{ key +1 }}</div>
          </div>
        </template>
      </div>
      <ol class="pl-3" v-if="showFindingNames && gastroFindings" >
        <li class="mb-2 font-weight-bold" v-for="(value, key) in findings" :key="key">
          {{ transI18n(value.name) }}
        </li>
      </ol>
    </div>
    <!-- <ul class="pl-3">
      <FindingsTypesLayout
        tag="li"
        :name="type"
        v-for="(value, type) in gastroFindings"
        :key="value.id"
      >
        <template #content>
          <template v-if="value.length">
            <li v-for="v in value" :key="v.id" class="mb-1">
              <FindingItemContent :finding="v" :images="getAllImages" />
            </li>
          </template>
          <p v-else>-</p>
        </template>
      </FindingsTypesLayout>
    </ul> -->
    <hr v-if="showFindingDescriptions" class="finding-description-divider mb-2 mt-2" />
    <ul v-if="showFindingDescriptions" class="pl-3 mb-3" style="list-style: none;">
      <li v-for="(v, key) in findings" :key="v.id" class="mb-1">
        <FindingItemContent 
          :finding="v" 
          :index="key+1" 
          :images="getAllImages" 
          :imgArrange="imgArrange" 
          :showImages="showFindingImages"
          :showMap="showFindingMap"
          :locationNumbers="getLocation(v, true)"
        />
      </li>
      <li v-if="showOtherImages" class="mb-1">
        <FindingOtherImages 
          :findings="findings" 
          :images="getAllImages" 
          :imgArrange="imgArrange" 
        />
      </li>
    </ul>
  </section>
</template>

<script>
import FindingsTypesLayout from '@/components/commons/FindingsTypesLayout.vue'
import FindingItemContent from '@/components/commons/FindingItemContent.vue'
import FindingOtherImages from '@/components/commons/FindingOtherImages.vue'
import GastroMixins from '@/components/commons/GastroMixins.js'
import {mapGetters, mapActions} from 'vuex'
import { findMatchI18n } from '@/utils/findMatchI18n'
import { getLocationByLesionsObservation } from '@/utils/finding'
import { GASTRO_LOCATION_MAP } from '@/utils/previewLocationMap'

export default {
  name: 'FindingInfoByOrgan',
  computed: {
    ...mapGetters('examinations', ['getExaminationData']),
    getAllImages() {
      if (this.getExaminationData && this.getExaminationData.all) {
        return this.getExaminationData.all.sort((a, b) => b.id - a.id)
      }
      return []
    },
  },
  components: {
    FindingItemContent,
    FindingsTypesLayout,
    FindingOtherImages
  },
  props: {
    findings: {
      type: Array,
      default: () => [],
    },
    imgArrange: {
      type: Number,
      default: 3
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showGlobalMap: {
      type: Boolean,
      default: true
    },
    showFindingNames: {
      type: Boolean,
      default: true
    },
    showFindingDescriptions: {
      type: Boolean,
      default: true
    },
    showFindingImages: {
      type: Boolean,
      default: true
    },
    showFindingMap: {
      type: Boolean,
      default: true
    },
    showOtherImages: {
      type: Boolean,
      default: true
    },
    /** EVAS2.0：要標示的座標編號陣列。說明見 FindingInfoByOrder 的同名 prop */
    spots: {
      type: Array,
      default: null
    }
  },
  mixins: [GastroMixins],
  data() {
    return {
      // 表本身搬到 utils/previewLocationMap，理由見 FindingInfoByOrder
      locationMap: GASTRO_LOCATION_MAP,
    }
  },
  methods: {
    getLocation(finding, multiple = false) {
      return getLocationByLesionsObservation(finding, this.locationMap, multiple)
    },
    transI18n(text) {
      return findMatchI18n(text)
    }
  },
  mounted() {
    console.log(this.gastroFindings)
  }
}
</script>
<style lang="scss" scoped>
.finding-description-divider{
  border: 0;
  border-top: 1px dashed #B6BAC3;
}
.highlight-area{
  display: grid;
  grid-template-columns: auto;
}
@media print {
  .global-preview-map{
    display: inline-block;
    zoom: 0.8;
  }
  @supports not (zoom: 1) {
    .global-preview-map{
      transform: scale(0.8);
      transform-origin: top center;
    }
  }
}
.highlight-point{
  position: absolute;
  top: 0;
  left: 0;
  width: 34px;
  height: 34px;
  display: flex;
  border-radius: 50%;
  background-color: rgba(13, 148, 136, 0.3);
  align-items: center;
  justify-content: center;
  > .highlight-inner-point{
    width: 26px !important;
    height: 26px !important;
    display: inline-block;
    border-radius: 50%;
    color: #ffffff;
    background-color: rgb(13, 148, 136)
  }
  &.highlight-1, &.highlight-4{
    top: 220px;
    left: 185px;
  }
  &.highlight-2{
    top:154px;
    left:181px;
  }
  &.highlight-3{
    top:189px;
    left:180px;
  }
  &.highlight-5{
    top:252px;
    left:187px;
  }
  &.highlight-6{
    top:331px;
    left:200px;
  }
  &.highlight-7{
    top:306px;
    left:246px;
  }
  &.highlight-8, &.highlight-11{
    top:378px;
    left:243px;
  }
  &.highlight-9, &.highlight-10{
    top:344px;
    left:252px;
  }
  &.highlight-12{
    top:411px;
    left:221px;
  }
  &.highlight-13{
    top:385px;
    left:195px;
  }
  &.highlight-14{
    top:425px;
    left:195px;
  }
  &.highlight-15{
    top:390px;
    left:137px;
  }
  &.highlight-16, &.highlight-17, &.highlight-18{
    top:411px;
    left:129px;
  }
  &.highlight-19{
    top:294px;
    left:192px;
  }
}
</style>